import React from 'react';
import { SdmTypography } from 'components/SdmTypography';
import { theme } from 'theme';
import { useIntl } from 'react-intl';
import translations from 'utils/translations';

const NotTranslatableMsg = () => {
  // Hooks
  const intl = useIntl();
  const i18n = translations.productPage(intl);
  return (
    <SdmTypography
      variant={'h5'}
      style={{ margin: 0, color: theme.colors.primary.red }}
    >
      {i18n.tooltip.errorTranslate}
    </SdmTypography>
  );
};

export default NotTranslatableMsg;
